import { BroadcastChannel } from "broadcast-channel";
import React from "react";
import styled from "styled-components";

import { useOnInitialMount } from "../hooks/useOnInitialMount";
import { getUrlOrg } from "../orgs";
import { LoginEvent } from "../route/LoginListener";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const LoginSuccessView: React.FunctionComponent = () => {
  const orgId = getUrlOrg();

  useOnInitialMount(async () => {
    const message: LoginEvent = {
      source: "login",
      orgId: orgId,
    };

    if (window.opener) {
      // BroadcastChannel is partitioned by top-level domain and so won't work
      // in an embed context. In that situation we also try to post a message to the
      // context that opened this window.
      window.opener.postMessage(message);
    }

    const loginEvents = new BroadcastChannel("login");
    await loginEvents.postMessage(message);
    await loginEvents.close();

    window.close();
  });

  return (
    <Container>
      Logged in successfully! It is now safe to close this window.
    </Container>
  );
};
